import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { CheckCircle2, AlertTriangle, Package, ScanLine, Truck } from 'lucide-react';
import { KpiCard } from './KpiCard';

export function DashboardBodega({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-6" data-testid="dashboard-bodega">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <KpiCard title="Total Recepciones" value={data.total_recepciones} icon={Package} color="text-violet-600" bgColor="bg-violet-50" />
        <KpiCard title="Con Escaneo" value={data.con_escaneo} icon={ScanLine} color="text-green-600" bgColor="bg-green-50" subtitle={`${Math.round((data.con_escaneo / (data.total_recepciones || 1)) * 100)}%`} />
        <KpiCard title="Sin Escaneo" value={data.sin_escaneo} icon={AlertTriangle} color="text-amber-600" bgColor="bg-amber-50" />
      </div>
      {data.recepciones_recientes?.length > 0 && (
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm font-bold flex items-center gap-2"><Truck className="w-4 h-4" /> Ultimas Recepciones</CardTitle></CardHeader>
          <CardContent>
            <table className="w-full text-xs">
              <thead><tr className="bg-gray-50 text-left"><th className="px-3 py-2">N Recepcion</th><th className="px-3 py-2">OC</th><th className="px-3 py-2">RUT</th><th className="px-3 py-2">Escaneo</th></tr></thead>
              <tbody>
                {data.recepciones_recientes.slice(0, 7).map((r, i) => (
                  <tr key={i} className="border-t hover:bg-gray-50"><td className="px-3 py-2 font-mono">{r.numero_recepcion}</td><td className="px-3 py-2">{r.numero_oc || '-'}</td><td className="px-3 py-2 font-mono text-[10px]">{r.rut_proveedor}</td><td className="px-3 py-2">{r.ruta_archivo ? <CheckCircle2 className="w-3.5 h-3.5 text-green-500" /> : <span className="text-gray-300">-</span>}</td></tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
